







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import i18nService from '@/_shared/services/i18n/i18n.service';
import VueI18n from 'vue-i18n';

@Component
export default class LinkGeneratorBase extends Vue {
  i18n: VueI18n = new VueI18n({ locale: this.$i18n.locale, messages: this.$i18n.messages });

  created(): void {
    this.retrieveData();
  }

  async retrieveData() {
    this.$store.dispatch('showLoading');
    try {
      await Promise.all([
        this.retrieveLocale(),
        this.retrieveSponsorIdParam(),
      ]);
    } finally {
      this.$store.dispatch('hideLoading');
    }
  }

  public async retrieveLocale(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const localeParam = urlParams.get('locale');
    const language = localeParam || this.$store.state.RepStore.rep?.localeIso || navigator.language || 'en-us';
    try {
      await i18nService.setLang(language, this.i18n);
    } catch (e) {
      this.i18n = this.$i18n;
    }
    return Promise.resolve();
  }

  private async retrieveSponsorIdParam(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const sponsorIdParam = urlParams.get('sponsorId') || this.$store.state.RepStore.rep?.did;
    await this.$store.dispatch('setLinkSponsorId', sponsorIdParam);
    return Promise.resolve();
  }
}
